import { createTooltip, getLocalizedMessage } from '@/core/shared'
import {
	isEnabledDefaults,
	setDisabledStateOfLockableAttributeControlsWithDefaultValues
} from '@/core/core_components/form/form'
import { initItemCopy } from '@/core/item_assistance/initItemCopy'

export function initSidebar (buttonTitles) {
	initScrollup()
	initSidebarButtonsTooltips(buttonTitles)
	initHelpButton()
	initChangeHistory()
	initDefaultValueButton()
}

function initScrollup () {
	$('.scrollup').click(function () {
		$('html, body').animate({ scrollTop: 0 }, 600)
		return false
	})
	$('.scrollup').addClass('sidebar_items-' + ($('.sidebar').children().length - 1).toString())
}

function initSidebarButtonsTooltips (buttonTitles) {
	_.each(buttonTitles, function (btnTitleForCreateTooltip) {
		var btnDescriptionForTooltipInSidebar = btnTitleForCreateTooltip

		//for composite titles:
		switch (btnTitleForCreateTooltip) {
		case 'switch-default-value': {
			btnDescriptionForTooltipInSidebar = 'switch.default.value'
			break
		}
		case 'drop-item-state': {
			btnDescriptionForTooltipInSidebar = 'drop.item.state'
			break
		}
		case 'groups': {
			btnDescriptionForTooltipInSidebar = 'enable.disable.groups'
			break
		}
		case 'copy-attribute-name': {
			btnDescriptionForTooltipInSidebar = 'copy.attribute.name'
			break
		}
		case 'recalculate-attributes': {
			btnDescriptionForTooltipInSidebar = 'recalculate.attributes'
			break
		}
		case 'change-history': {
			btnDescriptionForTooltipInSidebar = 'change.history'
			break
		}
		case 'copy-attributes-from-item': {
			btnDescriptionForTooltipInSidebar = 'copy.attributes.from.item'
			break
		}
		}

		createTooltip('sidebar_' + btnTitleForCreateTooltip, getLocalizedMessage(btnDescriptionForTooltipInSidebar), 'top')
	})
}

function initDefaultValueButton () {
	$('#sidebar_switch-default-value').click(function () {
		$(this).toggleClass('sidebar_marked-button')
		setDisabledStateOfLockableAttributeControlsWithDefaultValues(isEnabledDefaults())
	})
}

function initHelpButton () {
	$('#sidebar_help').click(function () {
		var hotkeysHtml = '<div class="alert-left-aligned">'

		var translateKeys = ['hotkeys.description.groups.switching',
			'hotkeys.description.groups.enable.disable',
			'hotkeys.description.multiple.attribute.add.new.element',
			'hotkeys.description.multiple.attribute.delete.element',
			'hotkeys.description.item.editing',
			'hotkeys.description.item.saving',
			'hotkeys.description.default.values.blocking.on.off'
		]

		var excelSplittedValue = getLocalizedMessage('excel.to.recalculate.and.refresh.formulas').split(':')

		for (var key in translateKeys) {
			var splittedValue = getLocalizedMessage(translateKeys[key]).split(':')
			hotkeysHtml += (_.size(splittedValue) === 2) ? ('<div class="row"><div class="col-sm-4"><p><span>' + splittedValue[1] + '</span></p></div><div class="col-sm-8"><p>' + splittedValue[0] + '</p></div></div>') : ('<p>' + key + '</p><br>')
		}
		hotkeysHtml += '<hr><div class="row"><div class="col-sm-4"><p><span>'+ excelSplittedValue[1] +'</span></p></div><div class="col-sm-8">' + excelSplittedValue[0] +'</p></div></div>'
		hotkeysHtml += '</div>'

		Swal.fire({
			title: getLocalizedMessage('help'),
			html: hotkeysHtml,
			buttonsStyling: false,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
			}
		})
	})
}

function initChangeHistory () {
	$('#sidebar_change-history').click(function () {
		Swal.fire({
			title: '<h3>' + getLocalizedMessage('change.history') + '</h3>',
			html: '<div id="change_history"></div>',
			buttonsStyling: false,
			showCloseButton: true,
			closeButtonHtml: '<p style="font-size: 1.5rem; ">&times;</p>',
			position: 'top',
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				container: 'change-history-container',
				popup: 'change-history-popup'
			},
			showConfirmButton: false,
			onOpen: function (el) {
				var props = {
					modal: el,
					itemId: editableTradeItem.itemId
				}
				window.initItemHistory(props, '#change_history')
			}
		})
	})
}

export function initCopyAttributesFromItem (context) {
	$('#sidebar_copy-attributes-from-item').click(function () {
		let li = '<li><a tabindex="-1">\n' +
			context.$t("item.view") +
			'\t\t</a></li>'

		context.attributesGroups.forEach(group => {
			li += '<li><a tabindex="-1">\n' +
				'Copy to ' +
				context.$t(group.title) +
				'\t\t</a></li>'
		})

		li += '<li><a tabindex="-1">\n' +
			context.$t("copy.all") +
			'\t\t</a></li>'

		Swal.fire({
			title: '<h3>' + getLocalizedMessage('copy.attributes') + '</h3>',
			html: '<div class="table_search_phrase">\n' +
				'\t<div id="search_phrase" class="uk-search uk-search-default">\n' +
				'\t\t<a class="uk-search-icon-flip" uk-search-icon></a>\n' +
				'\t\t<input class="uk-search-input uk-form-small" type="text" style="font-size: 14px" placeholder="' + context.$t("search") + '">\n' +
				'\t\t<span class="search_reset fa fa-times" tabindex="-1"></span>\n' +
				'\t</div>\n' +
				'\t\t</div>' +
				'<div id="context-menu" class="context-menu">\n' +
				'\t<ul class="dropdown-menu" role="menu">\n' +
				li +
				'\t</ul>\n' +
				'</div>' +
				'<div class="row table-area-row">\n' +
				'\t<div class="col-sm-12 table-area-col">\n' +
				'\t\t<table id="table" class="table"></table>\n' +
				'\t</div>\n' +
				'</div>' +
				'<div class="row table-footer">\n' +
				'\t<div class="col-xs-6 col-sm-3">\n' +
				'\t\t<div id="status-bar" class="status-bar"></div>\n' +
				'\t</div>\n' +
				'\t<div class="col-xs-12 col-sm-6">\n' +
				'\t\t<div id="pager" class="pager"></div>\n' +
				'\t</div>\n' +
				'\t<div class="col-sm-3">\n' +
				'\t\t<div id="pagerSize" class="page-sizer-container" style="font-size: 12px"></div>\n' +
				'\t</div>\n' +
				'</div>\n',
			buttonsStyling: false,
			width: '90%',
			showCloseButton: true,
			closeButtonHtml: '<p style="font-size: 1.5rem; ">&times;</p>',
			position: 'top',
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
			},
			showConfirmButton: false,
			onBeforeOpen: function (el) {
				initItemCopy(context)
			}
		})
	})
}

export function markSidebarItemStateButtons (unsavedStateExists, unsavedDataExists) {
	var styleName = 'sidebar_marked-button'
	unsavedStateExists ? $('#sidebar_drop-item-state')[0].classList.add(styleName) : $('#sidebar_drop-item-state')[0].classList.remove(styleName)
	unsavedDataExists ? $('#sidebar_save')[0].classList.add(styleName) : $('#sidebar_save')[0].classList.remove(styleName)
}
